import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function powerOfTwoValidator(): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {
    return powerOfTwo(control.value) ? null : { powerOfTwo: control.value };
  };
}

function powerOfTwo(x: number) {
  return Math.log2(x) % 1 === 0;
}
